import { Subject } from '~/rage/utils';
import { CaseItemRarity } from '~/shared';
import {
	DonateCurrencyShopItemClientConfig,
	DonateCurrencyShopTagClientConfig,
	DonateInventoryShopItemClientConfig,
	IChangeNameApplication,
	IDonateService,
} from './donateServiceTypes';

export class DonateServiceStub implements IDonateService {
	private changeNameApplication = new Subject<IChangeNameApplication | null>(
		null,
	);
	private changeNameRejectTimeoutId: ReturnType<typeof setTimeout> | null =
		null;
	private currencyShopItems = new Subject<DonateCurrencyShopItemClientConfig[]>(
		[
			{
				id: '1',
				name: '100000',
				price: 1000,
				amount: 100000,
				discount: 0,
				discountTimestampStart: 0,
				discountTimestampEnd: 0,
				enabledTimestampStart: 0,
				enabledTimestampEnd: 0,
				tags: [],
			},
			{
				id: '2',
				name: '2000',
				price: 2000,
				amount: 2000,
				discount: 0,
				discountTimestampStart: 0,
				discountTimestampEnd: 0,
				enabledTimestampStart: 0,
				enabledTimestampEnd: 0,
				tags: [],
			},
		],
	);
	private inventoryShopItems = new Subject<
		DonateInventoryShopItemClientConfig[]
	>([
		{
			donateItemId: 'ccl_m_1508',
			name: 'Custom Shirt 15',
			price: 1500,
			discount: 0.5,
			discountTimestampStart: 0,
			discountTimestampEnd: Date.now() + 1000 * 60 * 60 * 3,
			enabledTimestampStart: 0,
			enabledTimestampEnd: 0,
			tags: [],
			rarity: CaseItemRarity.RARE,
		},
		{
			donateItemId: 'audi_rs6c6',
			name: 'Audi RS6C6',
			price: 50000,
			discount: null,
			discountTimestampStart: 0,
			discountTimestampEnd: 0,
			enabledTimestampStart: 0,
			enabledTimestampEnd: Date.now() + 1000 * 60 * 60 * 24 * 2,
			tags: [],
			rarity: CaseItemRarity.LEGENDARY,
		},
	]);

	public async changeName(firstName: string, lastName: string): Promise<void> {
		console.log('donate: changeName', firstName, lastName);
		this.clearChangeNameRejectSchedule();
		this.changeNameApplication.next({
			status: 'pending',
			firstName,
			lastName,
		});
		this.changeNameRejectTimeoutId = setTimeout(() => {
			this.changeNameRejectTimeoutId = null;
			this.changeNameApplication.next({
				status: 'rejected',
				firstName,
				lastName,
				reason: 'Ник хуйня',
			});
		}, 20_000);
		return Promise.resolve();
	}

	private clearChangeNameRejectSchedule(): void {
		if (this.changeNameRejectTimeoutId !== null) {
			clearTimeout(this.changeNameRejectTimeoutId);
			this.changeNameRejectTimeoutId = null;
		}
	}

	public getChangeNameApplication(): Subject<IChangeNameApplication | null> {
		return this.changeNameApplication;
	}

	public async cancelChangeName(): Promise<void> {
		console.log('donate: cancelChangeName');
		this.clearChangeNameRejectSchedule();
		this.changeNameApplication.next(null);
		return Promise.resolve();
	}

	public getCurrencyShopItems(): Subject<DonateCurrencyShopItemClientConfig[]> {
		return this.currencyShopItems;
	}

	public getCurrencyShopTagById(
		_id: string,
	): DonateCurrencyShopTagClientConfig | null {
		return null;
	}

	public async buyCurrencyShopItem(itemId: string): Promise<void> {
		console.log('donate: buyCurrencyShopItem', itemId);
		return Promise.resolve();
	}

	public getInventoryShopItems(): Subject<
		DonateInventoryShopItemClientConfig[]
	> {
		return this.inventoryShopItems;
	}

	public async buyDonateShopItem(donateItemId: string): Promise<void> {
		console.log('donate:buyDonateShopItem', donateItemId);
		return Promise.resolve();
	}
}
